import styled from 'styled-components'

export const ImageContainer = styled.div`
  position: relative;
  cursor: ${({ isDragging }) => isDragging ? 'grabbing' : 'grab'};
  opacity: ${({ isDragging }) => isDragging ? 0.5 : 1};
  touch-action: none;
`

export const RemoveButton = styled.button`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #FF3939E6;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;

  &:hover {
    background: #FF3939;
  }
`

export const ImagePreview = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
  border: 2px solid ${({ isDragging }) => isDragging ? '#FCC100' : '#E0E0E0'};
`
